import PropTypes from 'prop-types';
import React from 'react';
import { StyledButton as Button } from '../../../CommonComponents/Button';
import { Actions, Icon, Message, Text, Title, Wrapper } from './styles';

const ErrorState = ({ onRetry, size }) => {
  return (
    <Wrapper size={size}>
      {size !== 'small' && (
        <Icon>
          <i className="fal fa-exclamation-circle" />
        </Icon>
      )}
      <Text size={size}>
        <Title>Oops!</Title>
        <Message>Something went wrong!</Message>
      </Text>

      {!!onRetry && (
        <Actions size={size}>
          <Button.Primary type="button" onClick={onRetry}>
            Try Again
          </Button.Primary>
        </Actions>
      )}
    </Wrapper>
  );
};

ErrorState.defaultProps = {
  size: 'medium',
  onRetry: null,
};

ErrorState.propTypes = {
  onRetry: PropTypes.func,
  size: PropTypes.oneOf(['medium', 'small']),
};

export default ErrorState;
